import React from 'react';

const ImportOptions = ({ sendEmails, onSendEmailsChange }) => {
  return (
    <div className="mb-4">
      <h6 style={{ color: '#74E8C7', fontSize: '16px' }}>Step 3: Import Options</h6>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="sendEmails"
          checked={sendEmails}
          onChange={(e) => onSendEmailsChange(e.target.checked)}
          style={{ 
            backgroundColor: '#0a183a',
            borderColor: '#74E8C7',
            color: '#74E8C7'
          }}
        />
        <label className="form-check-label" htmlFor="sendEmails" style={{ color: 'white' }}>
          Send welcome emails to new users
        </label>
        <div className="small" style={{ color: '#d6d8e1' }}>
          Users will receive login credentials and instructions via email
        </div>
      </div>
    </div>
  );
};

export default ImportOptions;